@if (imageUrl$ | async; as url) {
  @if (url | assetExists | async) {
    <img [src]="url" alt="" />
  } @else {
    <p class="product-initials">{{ productName }}</p>
  }
}
